const CACHE_KEY = "ordo_accent_color";

function darken(hex, amount) {
  let c = (hex || "").replace("#", "");
  if (c.length === 3) c = c.split("").map((x) => x + x).join("");
  const num = parseInt(c, 16);
  if (Number.isNaN(num)) return hex;
  const r = Math.max(0, (num >> 16) - amount);
  const g = Math.max(0, ((num >> 8) & 0x00ff) - amount);
  const b = Math.max(0, (num & 0x0000ff) - amount);
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}

export function applyAccentColor(color) {
  const root = document.documentElement;
  if (color) {
    root.style.setProperty("--brand-crimson", color);
    root.style.setProperty("--brand-crimson-hover", darken(color, 25));
  } else {
    root.style.removeProperty("--brand-crimson");
    root.style.removeProperty("--brand-crimson-hover");
  }
}

export function cacheAccentColor(color) {
  try {
    if (color) localStorage.setItem(CACHE_KEY, color);
    else localStorage.removeItem(CACHE_KEY);
  } catch {
    // localStorage unavailable, ignore
  }
}

// Apply any previously cached accent color immediately on module load,
// before React mounts, to avoid a flash of the default color on reload.
try {
  const cached = localStorage.getItem(CACHE_KEY);
  if (cached) applyAccentColor(cached);
} catch {
  // localStorage unavailable, ignore
}
